import { CompanyTitledPage } from "../../TitledPage";

import { SAMPLE_CUSTOMER_LIST, SAMPLE_CUSTOMER_SEND_GROUP_LIST, SAMPLE_CUSTOMER_SEND_GROUP_MEMBER_SHOP_LIST, SAMPLE_CUSTOMER_SHOP_LIST } from "../../../common/SampleData";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import { CompanyPartHeader } from "../../../components/PartHeader";
import { useLocation, useNavigate } from "react-router-dom";

import { useState } from "react";
import { Checkbox, MenuItem, OutlinedInput, Select, Stack } from "@mui/material";

import { SYSTEM_PATH_COMPANY } from "../../../App";
import DeleteCustomerSendGroupDialog from "../../../components/CustomerSendGroupDeleteDialog";

const getSelectingCustomerShopList = (customerShopList) => {
  return customerShopList.map((customerData) => ({
    customer_id: customerData.customer_id,
    customer_name: customerData.customer_name,
    selected_shop_list: customerData.shop_list.filter((shopData) => shopData.is_selected)
  }));
}

function CurrentSelectingShopListPart ({selectingCustomerShopList}) {
  return (
    <Box>
      <Typography>選択中の店舗</Typography>
      <Box border="1px black solid" padding={1} height="45vh" sx={{overflowY:"auto"}}>
        {
          selectingCustomerShopList.map((customerData) => {
            if (customerData.selected_shop_list.length > 0) {
              return (
                <>
                  <Typography fontWeight="bold">{customerData.customer_name}</Typography>
                  <Grid container>
                  {
                    customerData.selected_shop_list.map((shopData) => (
                      <Grid item xs="auto" marginLeft={2}>
                        <Typography>{shopData.shop_name}</Typography>
                      </Grid>
                    ))
                  }
                  </Grid>
                </>
              );
            }
            
            return null;
          })
        }
      </Box>
    </Box>
  )
}

function ShopSelectionPart ({customerShopList, setCustomerShopList}) {

  const [selectingCustomerIndexValue, setSelectingCustomerIndexValue] = useState("-1");

  const getShopsAllSelected = (customerIndex) => {
    if (customerIndex < 0) {
      return false;
    }    

    return customerShopList[customerIndex].shop_list.every((data) => data.is_selected);
  }

  const handleChangeSelectingCustomer = (event) => {
    setSelectingCustomerIndexValue(event.target.value);
  }

  const handleChangeShopChecked = (customerIndex, shopindex) => (event) => {
    let newCustomerList = [...customerShopList];
    newCustomerList[customerIndex].shop_list[shopindex].is_selected = event.target.checked;
    setCustomerShopList(newCustomerList);
  }

  const handleClickShopAllChanged = (customerIndex, checked) => (event) => {
    let newCustomerList = [...customerShopList];
    newCustomerList[customerIndex].shop_list.forEach((shopData) => {
      shopData.is_selected = checked;
    });
    setCustomerShopList(newCustomerList);
  }

  const selectingCustomerIndex = parseInt(selectingCustomerIndexValue);

  return (
    <Box>
      <Typography>店舗一覧</Typography>
      <Box border="1px black solid" padding={1} height="45vh" sx={{overflowX: "scroll"}}>      
        <Grid container spacing={2} alignItems="center">
          <Grid item xs="auto"  marginLeft={1}>
            <Typography>取引先</Typography>
          </Grid>
          <Grid item xs="auto">
            <Select
              value={selectingCustomerIndexValue}
              onChange={handleChangeSelectingCustomer}
              sx={{minWidth: 200}}
            >
              <MenuItem key="customer_unselected" value="-1">[未選択]</MenuItem>
              {
                customerShopList.map((customerData, i) => {
                  if (customerData.shop_list.length > 0) {
                    return (
                      <MenuItem key={`customer_${i}`} value={i.toString()}>
                        {customerData.customer_name}
                      </MenuItem>
                    );
                  }

                  return null;
                })                
              }   
            </Select>
          </Grid>
          <Grid item xs>
            <Button
              variant="contained"
              onClick={handleClickShopAllChanged(selectingCustomerIndex, !getShopsAllSelected(selectingCustomerIndex))}
              disabled={selectingCustomerIndex < 0}
            >
              {getShopsAllSelected(selectingCustomerIndex) ? "全解除" : "全選択"}
            </Button>
          </Grid>
        </Grid>
        <Grid container maxHeight="90%" direction="column" flexWrap="wrap">
        {
          selectingCustomerIndex < 0
            ? null
            : customerShopList[parseInt(selectingCustomerIndex)].shop_list.map((shopData, shopIndex) => (
              <Grid key={`shop_${shopIndex}`} item width="30%">
                <Grid container alignItems="center">
                  <Grid item xs="auto">
                    <Checkbox
                      checked={shopData.is_selected}
                      onChange={handleChangeShopChecked(selectingCustomerIndex, shopIndex)}
                    />
                  </Grid>
                  <Grid item xs>
                    <Typography>{shopData.shop_name}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))
        }
        </Grid>
      </Box>
    </Box>
  )
}

function CustomerSendGroupShopSelect ({customerShopList, setCustomerShopList}) {

  return (
    <Grid container spacing={2}>
      <Grid item xs>
        <CurrentSelectingShopListPart selectingCustomerShopList={getSelectingCustomerShopList(customerShopList)} />
      </Grid>
      <Grid item xs>
        <ShopSelectionPart customerShopList={customerShopList} setCustomerShopList={setCustomerShopList} />
      </Grid>
    </Grid>
  )
}


// 取引先送信グループ編集ページ
export default function CustomerSendGroupEditPage() {
  
  const location = useLocation()
  const navigate = useNavigate()
  const customerSendGroupId = location.state.customerSendGroupId;

  const customerSendGroupData = SAMPLE_CUSTOMER_SEND_GROUP_LIST.find((data) => data.customer_send_group_id === customerSendGroupId);
  const groupShopList = SAMPLE_CUSTOMER_SEND_GROUP_MEMBER_SHOP_LIST.filter((data) => data.customer_send_group_id === customerSendGroupId && data.delete_flag===false);

  const getInitialCustomerShopList = () => (SAMPLE_CUSTOMER_LIST
    .filter((customerData) => customerData.delete_flag === 0)
    .map((customerData) => ({
      customer_id: customerData.customer_id,
      customer_name: customerData.name,
      shop_list: SAMPLE_CUSTOMER_SHOP_LIST
          .filter((shopData) => shopData.customer_id === customerData.customer_id && shopData.delete_flag === 0)
          .map((shopData) => ({
            shop_id: shopData.shop_id,
            shop_name: shopData.name,
            is_selected: groupShopList.some((data) => data.customer_id === customerData.customer_id && data.shop_id === shopData.shop_id)
          }))
    }))
  );


  const [customerSendGroupNameInput, setCustomerSendGroupNameInput] = useState(customerSendGroupData.name);

  const [customerShopList, setCustomerShopList] = useState(getInitialCustomerShopList());

  const [dialogOpen, setDialogOpen] = useState(false);

  const handleFocusInput = (event) => {
    event.target.select();
  }

  const handleChangeCustomerSendGroupNameInput = (event) => {
    setCustomerSendGroupNameInput(event.target.value);
  }

  const onClickReturn = (event) => {
    navigate(-1);
  }

  const onClickDelete = (event) => {
    setDialogOpen(true);
  }

  const onCloseDeleteDialog = (event, deleted) => {
    setDialogOpen(false);
    if (deleted) {
      navigate(SYSTEM_PATH_COMPANY + "/customer_send_group_list")
    }
  }

  const onClickConfirm = (event) => {
    let customerSendGroupData = SAMPLE_CUSTOMER_SEND_GROUP_LIST.find((data) => data.customer_send_group_id === customerSendGroupId);
    customerSendGroupData.name = customerSendGroupNameInput;

    customerShopList.forEach((customerData) => {
      let customerId = customerData.customer_id;

      customerData.shop_list.forEach((shopData) => {
        let index = SAMPLE_CUSTOMER_SEND_GROUP_MEMBER_SHOP_LIST.findIndex((data) => (
          data.customer_send_group_id === customerSendGroupId
          && data.customer_id === customerId
          && data.shop_id === shopData.shop_id
          && !data.delete_flag
        ));

        if (index > 0 && !shopData.is_selected) {
          SAMPLE_CUSTOMER_SEND_GROUP_MEMBER_SHOP_LIST[index].delete_flag = true;
        }
        if (index < 0 && shopData.is_selected) {
          SAMPLE_CUSTOMER_SEND_GROUP_MEMBER_SHOP_LIST.push({
            customer_send_group_id: customerSendGroupId,
            customer_id: customerId,
            shop_id: shopData.shop_id,
            delete_flag: false
          })
        }        
      })
    })

    navigate(-1);

  }

  

  return (
    <CompanyTitledPage title="取引先送信グループ編集">
      <Typography>
        取引先送信グループID : {customerSendGroupData.customer_send_group_id.toString()}
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs>
          <Typography fontWeight="bold" fontSize={30}>
            {customerSendGroupData.name}
          </Typography>
        </Grid>
        <Grid item xs='auto'>
          <Button variant="contained" onClick={onClickConfirm}>確定</Button>
        </Grid> 
        <Grid item xs='auto'>
          <Button variant="outlined" onClick={onClickReturn}>戻る</Button>
        </Grid>        
      </Grid>

      <Box marginTop={2}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs="auto">
            <Typography>
              新グループ名
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <OutlinedInput
              onFocus={handleFocusInput} onChange={handleChangeCustomerSendGroupNameInput}
              value={customerSendGroupNameInput} 
              sx={{width: 400}}
            />
          </Grid>        
        </Grid>
      </Box>   


      <CompanyPartHeader>        
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>店舗選択</Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" color="error" onClick={onClickDelete}>取引先グループ削除</Button>
          </Grid>   
        </Grid>
      </CompanyPartHeader>

      
      <CustomerSendGroupShopSelect customerShopList={customerShopList} setCustomerShopList={setCustomerShopList} />

      <DeleteCustomerSendGroupDialog open={dialogOpen} onCloseDialog={onCloseDeleteDialog} customerSendGroupData={customerSendGroupData} />
     
    </CompanyTitledPage>
  );
}
